import {ReactElement, useEffect, useState} from "react";
import {useAuthenticationContext} from "./AuthenticationContext";
import {VivoPortal} from "../AppConstants";
import EnumMemberGroupAliases = VivoPortal.EnumMemberGroupAliases;
import {JwtUtils} from "./JwtUtils";
import getToken = JwtUtils.getToken;
import {AccessRule, buildAccessRuleContext, isAccessRuleSatisfied} from "./accessRule";

export default function Authorized(props: authorizedProps) {
    const [isRoleAuthorized, setIsRoleAuthorized] = useState<boolean>(false);
    const [isLabAuthorized, setIsLabAuthorized] = useState<boolean>(true);
    const [isDivisionAuthorized, setIsDivisionAuthorized] = useState<boolean>(true);
    const {roleMask, rootModel} = useAuthenticationContext();
    useEffect(() => {
        if (props.roleMask)
        {
            setIsRoleAuthorized((roleMask & props.roleMask) > 0 && getToken() != null);
        }
        else 
            setIsRoleAuthorized(true);
        if (props.labFilter && props.labFilter.length > 0) {
            if (!rootModel ||( props.labFilter!.indexOf((rootModel.CurrentUserProfile.LabId ?? -1)) < 0))
                setIsLabAuthorized(false);
            else
                setIsLabAuthorized(true);
        }
        if (props.divisionFilter && props.divisionFilter.length > 0) {
            if (!rootModel ||( props.divisionFilter!.indexOf((rootModel.CurrentUserProfile.DivisionId ?? -1)) < 0))
                setIsDivisionAuthorized(false);
            else
                setIsDivisionAuthorized(true);
        }
    }, [roleMask, rootModel]);
    // evaluated during render (not through the effect state above), so it is never one render behind the context
    const isAccessRuleAuthorized = isAccessRuleSatisfied(props.accessRule, buildAccessRuleContext(roleMask, rootModel, getToken()));
    return (
        <>
            {(isRoleAuthorized && isLabAuthorized && isDivisionAuthorized && isAccessRuleAuthorized) ? props.children : props.notAuthorized}
        </>
    )
}

export interface authorizedProps {
    children: ReactElement;
    notAuthorized?: ReactElement;
    roleMask? : EnumMemberGroupAliases;
    labFilter? : number[]
    divisionFilter? : number[]
    /** Optional extra decision, ANDed with the filters above (see accessRule.ts). */
    accessRule? : AccessRule
}